// React
import { memo } from "react";

// Helpers
import moment from "moment";

// Servisni sloj
import { INCOMING_SOURCE_LABELS, PROVIDER_LABELS } from "services/api/finance/incoming-invoices/consts";

import { InvoiceIncomingOriginBadgeProps } from "./types";

/**
 * Porijeklo računa uz naslov kartice — je li stigao kroz providera ili je unesen ručno.
 * Podatak se čita jednom pri otvaranju, pa stoji u zaglavlju umjesto da troši redak obrasca.
 */
const InvoiceIncomingOriginBadge: React.FC<InvoiceIncomingOriginBadgeProps> = (props) => {
  const { invoice } = props;

  const isFromProvider = invoice.incomingSourceId === "provider";

  const sourceLabel = INCOMING_SOURCE_LABELS[invoice.incomingSourceId ?? ""] ?? "Nepoznat izvor";
  const providerLabel = invoice.providerName
    ? PROVIDER_LABELS[invoice.providerName] ?? invoice.providerName
    : null;

  const parts = isFromProvider
    ? [
      sourceLabel,
      providerLabel,
      invoice.providerInvoiceId ? `dokument ${invoice.providerInvoiceId}` : null,
      invoice.receivedFromProviderAt
        ? `zaprimljen ${moment(invoice.receivedFromProviderAt).format("DD.MM.YYYY. HH:mm")}`
        : null,
    ]
    : [
      sourceLabel,
      invoice.created ? `unesen ${moment(invoice.created).format("DD.MM.YYYY. HH:mm")}` : null,
    ];

  const label = parts.filter(Boolean).join(" · ");
  if (!label) return null;

  return (
    <span
      className={
        isFromProvider
          ? "inline-flex items-center rounded-full bg-sky-50 text-sky-700 border border-sky-200 px-3 py-1 text-xs font-medium"
          : "inline-flex items-center rounded-full bg-slate-100 text-slate-600 border border-slate-200 px-3 py-1 text-xs font-medium"
      }
    >
      {label}
    </span>
  );
};

export default memo(InvoiceIncomingOriginBadge);
